import { render, staticRenderFns } from "./AnswerText.vue?vue&type=template&id=aba757a8&scoped=true&"
import script from "./AnswerText.vue?vue&type=script&lang=js&"
export * from "./AnswerText.vue?vue&type=script&lang=js&"
import style0 from "./AnswerText.vue?vue&type=style&index=0&id=aba757a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba757a8",
  null
  
)

export default component.exports